import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Interpolate } from 'react-i18next';
import classNames from 'classnames';
import CommentHeader from '../comment-header';
import CommentFooter from '../comment-footer';
import { DraftRenderer } from '../styled-text-editor';
import TimeAgo from '../../components/time-ago';
import withTranslate from '../../hoc/with-translate';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withFontClassName from '../../hoc/with-font-class-name';
import withTopCommentColor from '../../hoc/with-top-comment-color';
import getImageUrl from '../../services/get-image-url';
import styles from './comment.scss';

const MAX_PHOTO_HEIGHT = 600;
const PHOTO_QUALITY = 60;

class Comment extends Component {
  componentDidMount() {
    const { reportBottomPosition } = this.props;
    if (reportBottomPosition) {
      reportBottomPosition(this.ref.offsetTop + this.ref.offsetHeight);
    }
  }

  renderImage() {
    const { comment: { image } } = this.props;

    if (!image) {
      return null;
    }

    return (
      <div>
        <img className={styles.image} src={getImageUrl(image, undefined, MAX_PHOTO_HEIGHT, PHOTO_QUALITY)}/>
      </div>
    );
  }

  setComment = ref => {
    this.ref = ref;
  };

  renderBody() {
    const { comment } = this.props;

    let commentBody = null;
    if (typeof comment.content === 'object') {
      commentBody = <DraftRenderer type="comment" content={comment.content}/>;
    }
    return commentBody;
  }

  renderEditDate() {
    const { comment } = this.props;

    if (!comment.editedDate) {
      return null;
    }

    return (
      <p className={styles.editDate} data-hook="edit-date">
        <Interpolate i18nKey="comment.edited" timeAgo={<TimeAgo time={comment.editedDate}/>}/>
      </p>
    );
  }

  render() {
    const { comment, borderWidth, contentFontClassName, isTopComment, topCommentColor } = this.props;
    const commentClass = classNames(
      styles.comment,
      contentFontClassName,
      'forum-text-color',
      'forum-card-background-color',
      'forum-card-border-color',
      'comment'
    );
    const commentStyle = { borderWidth };

    let markerClass;
    let markerStyle;

    if (isTopComment) {
      markerClass = classNames('button-background-color', styles.commentMarker);
      markerStyle = { width: Math.max(borderWidth, 3) };
      if (topCommentColor) {
        markerStyle.backgroundColor = topCommentColor;
      }
    }

    return (<div className={styles.commentWrapper}>
      {isTopComment && <div className={markerClass} style={markerStyle} data-hook="marker"/>}
      <article id={comment._id} ref={this.setComment} className={commentClass} style={commentStyle} data-hook="comment">
        <div className={styles.contentWrapper}>
          <div className={styles.header}>
            <CommentHeader comment={comment} showMoreButton showTopComment={isTopComment}/>
          </div>
          {this.renderEditDate()}
          <div className={classNames(styles.content, 'comment__content')}>
            {this.renderBody()}
            {this.renderImage()}
          </div>
          <CommentFooter
            comment={comment}
            onLikeClick={this.props.onLikeClick}
            onReplyClick={this.props.onReplyClick}
            showReplyLink
          />
        </div>
      </article>
    </div>
    );
  }
}

Comment.propTypes = {
  comment: PropTypes.object.isRequired,
  t: PropTypes.func,
  onLikeClick: PropTypes.func.isRequired,
  onReplyClick: PropTypes.func,
  reportBottomPosition: PropTypes.func,
  borderWidth: PropTypes.number.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  isTopComment: PropTypes.bool,
  topCommentColor: PropTypes.string,
};

export default flowRight(
  withFontClassName,
  withTranslate,
  withCardBorderWidth,
  withTopCommentColor,
)(Comment);



// WEBPACK FOOTER //
// ./app/components/comment/comment.js